module.exports = __webpack_public_path__ + "img/hejifufm.b36c4238.jpg";